{
    "cat-error-codes-quick-search-fields": [
        {
            "label": "Error Code", "columnname": "Error_Code", "placeholder": "Error Code",
            "width": "", "datatype": "String", "isLarge": false
        }
    ],
    "cat-error-codes-grid-columns": [
        {
            "display": "true",
            "ui_columnname": "Error Code",
            "db_columnname": "Error_Code",
            "datatype": "String",
            "mappingkey": "Error_Code",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Error Code Description",
            "db_columnname": "Error_Code_Description",
            "datatype": "String",
            "mappingkey": "Error_Code_Description",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Explanation",
            "db_columnname": "Explanation",
            "datatype": "String",
            "mappingkey": "Explanation",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Warning Error",
            "db_columnname": "Warning_Error",
            "datatype": "String",
            "mappingkey": "Warning_Error",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "Stored Procedure Name",
            "db_columnname": "Store_Procedure_Name",
            "datatype": "String",
            "mappingkey": "Store_Procedure_Name",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "IsActive",
            "db_columnname": "IsActive",
            "datatype": "String",
            "mappingkey": "IsActive",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }
    ]
}